<template>
    <v-content>
        <v-app>
            <v-container grid-list-md text-xs-center fluid>
                <v-layout row wrap>
                    <v-flex xs6>
                        <v-card class="pa-2">
                            <canvas ref="transactions-value-weekly-comparison" id="transactions-value-weekly-comparison" width="400" height="400"></canvas>
                        </v-card>
                    </v-flex>
                    <v-flex xs6>
                        <v-card class="pa-2">
                            <canvas ref="transactions-volume-weekly-comparison" id="transactions-volume-weekly-comparison" width="400" height="400"></canvas>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12>
                        <v-card>
                            <!-- <v-card-title class="justify-center comparison-table-title">Weekly Transactions Value & Volume Comparison</v-card-title> -->
                            <v-data-table id="comparison-table" :headers="headers" :items="data" :loading="loading" hide-actions>
                            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                <template v-slot:items="props">
                                    <td class="text-xs-left font-weight-bold" :style="{color:'rgba(0,0,0,.54)'}">{{ props.item.day }}</td>
                                    
                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVal) }}<br>
                                                {{ props.item.dbValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbVal) }}<br>
                                                {{ props.item.dbValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbVol) }}<br>
                                                {{ props.item.dbVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbVol) }}<br>
                                                {{ props.item.dbVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.crValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.crVal) }}<br>
                                                {{ props.item.crValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.crVal) }}<br>
                                                {{ props.item.crValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.crVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.crVol) }}<br>
                                                {{ props.item.crVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.crVol) }}<br>
                                                {{ props.item.crVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbFailValChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbFailVal) }}<br>
                                                {{ props.item.dbFailValChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(props.item.dbFailVal) }}<br>
                                                {{ props.item.dbFailValChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout v-if="Math.sign(props.item.dbFailVolChange) == 1" row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#e53935">mdi-arrow-up-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbFailVol) }}<br>
                                                {{ props.item.dbFailVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                        <v-layout v-else row wrap align-center>
                                            <v-flex xs2><v-icon size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon></v-flex>
                                            <v-flex>
                                                {{ new Intl.NumberFormat().format(props.item.dbFailVol) }}<br>
                                                {{ props.item.dbFailVolChange }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    
                                    <td class="text-xs-left">
                                        <v-layout row wrap align-center>
                                            <v-flex xs2>
                                                <v-icon v-if="props.item.failureRateVal > props.item.lastFailureRateVal" class="mr-1" size="16" color="#e53935">mdi-arrow-up-bold</v-icon>
                                                <v-icon v-else class="mr-1" size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon>
                                            </v-flex>
                                            <v-flex>
                                                {{ props.item.failureRateVal }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>

                                    <td class="text-xs-left">
                                        <v-layout row wrap align-center>
                                            <v-flex xs2>
                                                <v-icon v-if="props.item.failureRateVol > props.item.lastFailureRateVol" class="mr-1" size="16" color="#e53935">mdi-arrow-up-bold</v-icon>
                                                <v-icon v-else class="mr-1" size="16" color="#66bb6a">mdi-arrow-down-bold</v-icon>
                                            </v-flex>
                                            <v-flex>
                                                {{ props.item.failureRateVol }}%
                                            </v-flex>
                                        </v-layout>
                                    </td>
                                    
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-app>
    </v-content>
</template> 

<script>
    import renderTransactionsValueComparison from '../charts.js';
    import renderTransactionsVolumeComparison from '../charts.js';
    import axios from 'axios';

    export default {
        data () {
            return {
                headers: [ { text: 'Day', sortable: false },
                           { text: 'Debit Val.', sortable: false },
                           { text: 'Debit Vol.', sortable: false },
                           { text: 'Credit Val.', sortable: false },
                           { text: 'Credit Vol.', sortable: false },
                           { text: 'Rejected Val.', sortable: false },
                           { text: 'Rejected Vol.', sortable: false },
                           { text: 'Failure Rate Val.', sortable: false },
                           { text: 'Failure Rate Vol.', sortable: false } ],
                data: [],
                loading: true,
                canvasValue: null
            }
        },
        mixins: [ renderTransactionsValueComparison, renderTransactionsVolumeComparison ],
        mounted() {
            this.canvasValue = this.$refs['transactions-value-weekly-comparison'].getContext('2d');
            this.canvasVolume = this.$refs['transactions-volume-weekly-comparison'].getContext('2d');
        },
        beforeMount() {
            this.getDashboardWeeklyStats();
        },
        methods: {
            getDashboardWeeklyStats() {
                axios({
                method: 'get',
                url: 'https://controlapi.totalprocessing.com/api/get-dashboard-weekly-stats',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    // console.log(response.data);
                    this.loading = false;
                    this.data = response.data;
                    this.renderTransactionsValueComparison(this.canvasValue, this.data, 'weekly');
                    this.renderTransactionsVolumeComparison(this.canvasVolume, this.data, 'weekly');
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        }
    }
</script>

<style>

#comparison-table .v-table thead th,
#dashboard-comparison-table .v-table tbody td {
    padding: 0px 20px;
}

#comparison-table .v-table thead tr.v-datatable__progress > th.column {
    padding: 0px;
}

.comparison-table-title {
    font-size: 12px;
    font-weight: 600;
    color: rgba(0, 0, 0, .54);
    padding: 15px 0px 0px 0px !important;
}

</style>
